export default __webpack_public_path__ + "img/21.asset.154a0850.jpeg";